module.exports = "<div class=\"login-info\">\r\n  <span><a (click)=\"toggleShortcut()\">\r\n\t   <img [src]=\"user.picture\" alt=\"me\" src-fallback=\"/dist/assets/img/avatars/default.png\"\r\n          class=\"online\"/><span>{{user.username }}</span> <i class=\"fa fa-angle-down\"></i>\r\n    </a>\r\n   </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = ./src/app/shared/user/login-info/login-info.component.html
// module chunks = main